import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	past48Hours: {
		id: 'servicedesk-reports-common.date-filter.past-48-hours',
		defaultMessage: 'Past 48 hours',
		description: 'Text for selecting date range by Past 48 hours in a dropdown',
	},
	past7Days: {
		id: 'servicedesk-reports-common.date-filter.past-7-days',
		defaultMessage: 'Past 7 days',
		description: 'Text for selecting date range by Past 7 days in a dropdown',
	},
	past14Days: {
		id: 'servicedesk-reports-common.date-filter.past-14-days',
		defaultMessage: 'Past 14 days',
		description: 'Text for selecting date range by Past 14 days in a dropdown',
	},
	past30Days: {
		id: 'servicedesk-reports-common.date-filter.past-30-days',
		defaultMessage: 'Past 30 days',
		description: 'Text for selecting date range by Past 30 days in a dropdown',
	},
	pastQuarterByDay: {
		id: 'servicedesk-reports-common.date-filter.past-quarter-by-day',
		defaultMessage: 'Past quarter by day',
		description: 'Text for selecting date range by Past quarter by day in a dropdown',
	},
	pastQuarterByWeek: {
		id: 'servicedesk-reports-common.date-filter.past-quarter-by-week',
		defaultMessage: 'Past quarter by week',
		description: 'Text for selecting date range by Past quarter by week in a dropdown',
	},
	pastYearByWeek: {
		id: 'servicedesk-reports-common.date-filter.past-year-by-week',
		defaultMessage: 'Past year by week',
		description: 'Text for selecting date range by Past year by week in a dropdown',
	},
	pastYearByMonth: {
		id: 'servicedesk-reports-common.date-filter.past-year-by-month',
		defaultMessage: 'Past year by month',
		description: 'Text for selecting date range by Past year by month in a dropdown',
	},
	customDates: {
		id: 'servicedesk-reports-common.date-filter.custom-dates',
		defaultMessage: 'Custom range',
		description: 'The option for a custom date range in the date filter dropdown',
	},
	dropdownLabel: {
		id: 'servicedesk-reports-common.date-filter.dropdown-label',
		defaultMessage: 'Show',
		description:
			'Label for the dropdown asking the user to input a date range for which we will show data',
	},
});
